import { IMarque, Marque } from './../../models/Marque.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MarqueService } from 'src/app/_services/marque.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-marque-update',
  templateUrl: './marque-update.component.html',
  styleUrls: ['./marque-update.component.css']
})
export class MarqueUpdateComponent implements OnInit {
  form: any = {};
  marque: Marque;
  updateCase =false;
  constructor(private route: ActivatedRoute,private marqueService: MarqueService) { }

  ngOnInit() {
    this.marque = new Marque();
    if (this.route.snapshot.paramMap.get("id")) {
      this.marqueService
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: any) => {
          console.log(data);
          this.marque = data;
          this.updateForm(this.marque);
        });
    }else{
      this.updateCase = true
      this.marque = new Marque();
      console.log(this.updateCase);
    }

  }

  updateForm(marque: IMarque): void {
    this.form.id = marque.id;
    this.form.marqueLib = marque.marqueLib;
  }

  onSubmit() {
    if (this.route.snapshot.paramMap.get("id")) {
      console.log("Form", this.form);
      this.marque = this.form;
      this.marqueService.updateData(this.marque.id, this.marque).subscribe((data) => {
        console.log("Updated man!!");
        console.log(data);
        this.retour();
      });
    } else {
      this.marque = this.form;
      console.log("Marque", this.marque);
      this.marqueService.insertData(this.marque).subscribe(
        (data) => {
          console.log(data);
          this.retour();
          this.AlertSaveSucces();
        },
        (err) => {
          this.AlertSaveFailed();
          //this.errorMessage = err.error.message;
        }
      );
    }
  }

  retour() {
    window.history.back();
  }
  AlertSaveSucces() {
    Swal.fire({
      icon: 'success',
      title: 'Marque enregistrée avec succès',
      showConfirmButton: true,
    });
  }

  AlertSaveFailed() {
    Swal.fire({
      icon: 'warning',
      title: 'Marque non enregistrée vérifier votre connexion internet puis réessayer !!',
      showConfirmButton: true,
    });
  }


}
